import { Component } from '@angular/core';

@Component ({
    templateUrl: '403.html'
})

export class Page403Component {
    constructor() { }
}